/* Cover My Plate · design uploads that never hold up the cart or checkout (checkout plan Phase 1, Nov 2026).
   Every builder posts {base64Image, filename} to .../api/upload-shopify-file and waits for {url, id}. This
   wraps fetch for that endpoint and sends the file straight to Proof Hub's storage instead (as raw bytes, a
   third smaller than the old base64 JSON), at a link the browser decides up front:
     https://fvjgjdxsnmjhvhalqnot.supabase.co/storage/v1/object/public/design-files/k/<key>/<name>.<ext>
   so the builder can get its link before the upload has finished:
     - the customer's own files (logo, background photo) start uploading the moment they're picked, while the
       customer is still designing. At Add to cart the builder sends the same file again; it's recognised by its
       fingerprint (SHA-256) and gets the link of the copy that's already up, so there's nothing left to send.
       Only if it's still on its way does Add to cart wait for it, up to 45 seconds, with a percent-done bar.
       (Files picked but never ordered stay in storage too.)
     - previews, print files, mock-ups and other backups: no wait at all. If the cart page opens before the
       preview has landed, it shows the copy kept on the phone.
   Anything unfinished keeps uploading in the background, is kept on the phone (IndexedDB) and picks up again
   on the next page of the store, for up to a day. Checkout never waits. Proof Hub records every file that
   arrives (design_uploads) and flags an order whose file never did.
   If Proof Hub storage turns a file down, that file goes the old way (Vercel endpoint, via cmp-upload-fit).
   SVG and other non-image files also go the old way. Loaded from sections/cmp-seo.liquid after cmp-upload-fit.js.
   Nov 3 2026 fix (orders 18829, 18839, 18844 lost their print files and previews): on iPhones the background
   upload died when the page moved on to the cart, and the next-page retry never ran. Now:
     - Add to cart waits for the files the order needs (print file, main preview) to land, with the percent-done
       bar, at most 20 seconds in all. Match pictures and made-again extras (AI backgrounds, mock-ups) go in the
       background; Check out waits for them.
     - Check out (button and express buttons on the cart page) waits for anything still uploading.
     - The upload starts at once instead of after the phone copy is saved, and the phone copy is kept as plain
       bytes (iPhone Safari is more reliable with those than with a Blob). Four uploads at a time, not two. */
(function() {
 'use strict';
 if (window.__cmpUploads || !window.fetch || typeof Response === 'undefined' || typeof Blob === 'undefined') return;
 window.__cmpUploads = true;

 var EP = 'https://fvjgjdxsnmjhvhalqnot.supabase.co/functions/v1/design-upload';
 var PUB = 'https://fvjgjdxsnmjhvhalqnot.supabase.co/storage/v1/object/public/design-files/';
 var LEGACY = /upload-shopify-file/;
 var MIMES = { png: 'image/png', jpg: 'image/jpeg', jpeg: 'image/jpeg', webp: 'image/webp' };
 var EXTS = { 'image/png': 'png', 'image/jpeg': 'jpg', 'image/webp': 'webp' };
 var WAIT = { customer: 45000, preview: 20000, print: 20000, extra: 0 };
 /* Files the order needs (print file, main preview) are waited for at Add to cart, but one Add to cart never waits
    more than 20 s in total for them, however many there are (phones: median ~3 s, slowest seen ~20 s, Nov 2-3 logs).
    Match pictures for the cart tiles ("match-…") don't wait: they upload in the background and Check out waits for them. */
 var budgetEnd = 0;
 function waitFor(job) {
  if (job.kind !== 'preview' && job.kind !== 'print') return WAIT[job.kind];
  if (/^match-/i.test(job.name)) return 0;
  var now = Date.now();
  if (now > budgetEnd + 5000) budgetEnd = now + WAIT[job.kind]; // a new Add to cart
  return Math.max(0, budgetEnd - now);
 }
 var RANK = { customer: 0, preview: 1, print: 2, extra: 3 };
 var DAY = 86400000;
 var prevFetch = window.fetch; // cmp-upload-fit's wrapper (or the browser's own fetch)

 /* ---------- naming: must match design-upload's baseName() ---------- */
 function baseName(name) {
  return String(name || '').replace(/\.[a-z0-9]+$/i, '').replace(/[^a-z0-9_-]+/gi, '-').slice(0, 60) || 'file';
 }
 function newKey() {
  var r = '';
  for (var i = 0; i < 12; i++) r += Math.floor(Math.random() * 36).toString(36);
  return (Date.now().toString(36) + r).slice(0, 24);
 }
 /* What a file is, from the name the builder gave it. */
 function kindOf(name) {
  var n = String(name || '');
  if (/PRINT/.test(n)) return 'print';
  if (/-ai-background|on-their-car/i.test(n)) return 'extra'; // made by us, can be made again
  if (/-logo|original|upload/i.test(n) || /^custom-.*-background\./i.test(n)) return 'customer'; // a builder's own background (jp-frame-…-background) is made by the site
  if (/preview/i.test(n)) return 'preview';
  return 'extra';
 }

 function bodyOf(init) {
  if (!init || typeof init.body !== 'string' || init.body.charAt(0) !== '{') return null;
  try {
   var j = JSON.parse(init.body);
   return j && typeof j.base64Image === 'string' && j.base64Image.length > 32 ? j : null;
  } catch (e) {
   return null;
  }
 }
 function mimeOf(data, name) {
  var m = /^data:([^;,]+)/.exec(data.slice(0, 64));
  var t = m ? m[1].toLowerCase() : '';
  if (!t) t = MIMES[((/\.([a-z0-9]+)$/i.exec(name || '') || [])[1] || '').toLowerCase()] || '';
  return t === 'image/jpg' ? 'image/jpeg' : t;
 }
 function toBlob(data, type) {
  var i = data.indexOf(',');
  var b64 = data.slice(0, 5) === 'data:' ? data.slice(i + 1) : data;
  var bin = atob(b64), n = bin.length, u8 = new Uint8Array(n);
  for (var k = 0; k < n; k++) u8[k] = bin.charCodeAt(k);
  return new Blob([u8], { type: type });
 }
 function jsonResponse(obj, status) {
  return new Response(JSON.stringify(obj), { status: status || 200, headers: { 'Content-Type': 'application/json' } });
 }
 function sleep(ms) {
  return new Promise(function(r) { setTimeout(r, ms); });
 }

 /* ---------- kept on the phone until uploaded ---------- */
 var DBP = null;
 function db(name, store, key) {
  return new Promise(function(res) {
   try {
    var rq = indexedDB.open(name, 1);
    rq.onupgradeneeded = function() { rq.result.createObjectStore(store, { keyPath: key }); };
    rq.onsuccess = function() { res(rq.result); };
    rq.onerror = function() { res(null); };
    rq.onblocked = function() { res(null); };
   } catch (e) {
    res(null);
   }
  });
 }
 function idb(d, store, op, val) {
  if (!d) return Promise.resolve(null);
  return new Promise(function(res) {
   try {
    var tx = d.transaction(store, op === 'all' || op === 'get' ? 'readonly' : 'readwrite'), s = tx.objectStore(store);
    var rq = op === 'put' ? s.put(val) : op === 'del' ? s.delete(val) : op === 'get' ? s.get(val) : s.getAll();
    rq.onsuccess = function() { res(rq.result); };
    rq.onerror = function() { res(null); };
   } catch (e) {
    res(null);
   }
  });
 }
 function jobs(op, val) {
  if (!DBP) DBP = db('cmp-design-uploads', 'jobs', 'key');
  // never let a stuck database hold anything up
  return Promise.race([DBP.then(function(d) { return idb(d, 'jobs', op, val); }), sleep(4000).then(function() { return null; })]);
 }
 /* Keep a copy on the phone as plain bytes (not a Blob), in case this page closes before the upload lands. */
 var landed = {};
 function stash(job) {
  if (!job.blob || !job.blob.arrayBuffer) return jobs('put', job);
  return job.blob.arrayBuffer().then(function(buf) {
   if (landed[job.key]) return null;
   return jobs('put', { key: job.key, name: job.name, kind: job.kind, type: job.type, at: job.at, url: job.url, buf: buf }).then(function() {
    if (landed[job.key]) jobs('del', job.key); // finished while we were saving the copy
   });
  }).catch(function() { return null; });
 }
 function revive(job) {
  if (job && !job.blob && job.buf) job.blob = new Blob([job.buf], { type: job.type });
  return job;
 }

 /* ---------- the upload itself: XHR so we get a percent-done ---------- */
 function send(job, onProgress) {
  return new Promise(function(res) {
   var x = new XMLHttpRequest();
   x.open('POST', EP + '?key=' + job.key + '&kind=' + job.kind + '&name=' + encodeURIComponent(job.name));
   x.setRequestHeader('Content-Type', job.type);
   x.timeout = 120000;
   if (onProgress && x.upload) x.upload.onprogress = function(e) { if (e.lengthComputable) onProgress(e.loaded / e.total); };
   x.onload = function() {
    var ok = x.status >= 200 && x.status < 300;
    // 4xx (other than too-many) means storage won't take this file: retrying won't help
    res(ok ? 'ok' : (x.status >= 400 && x.status < 500 && x.status !== 429 && x.status !== 408) ? 'refused' : 'retry');
   };
   x.onerror = x.ontimeout = x.onabort = function() { res('retry'); };
   x.send(job.blob);
  });
 }

 /* One queue, the customer's own files first, four at a time. */
 var queue = [], active = 0, live = {};
 function pump() {
  while (active < 4 && queue.length) {
   queue.sort(function(a, b) { return RANK[a.job.kind] - RANK[b.job.kind] || a.job.at - b.job.at; });
   run(queue.shift());
  }
 }
 function run(item) {
  active++;
  var job = item.job, tries = 0;
  (function attempt() {
   tries++;
   send(job, function(f) { if (item.progress) item.progress(f); }).then(function(r) {
    if (r === 'retry' && tries < 3) return sleep(tries * 3000).then(attempt);
    active--;
    pump();
    if (r === 'ok') { landed[job.key] = 1; jobs('del', job.key); }
    else if (r === 'refused' || Date.now() - job.at > DAY) jobs('del', job.key);
    item.done(r);
   });
  })();
 }
 /* Resolves to 'ok', 'refused' or 'retry' (try again on a later page). */
 function upload(job) {
  if (live[job.key]) return live[job.key].p;
  var item = { job: job, progress: null };
  item.p = new Promise(function(r) { item.done = r; }).then(function(r) {
   delete live[job.key];
   busy();
   return r;
  });
  live[job.key] = item;
  busy();
  queue.push(item);
  pump();
  return item.p;
 }

 /* ---------- percent-done bar while Add to cart waits on the customer's own file ---------- */
 var bar = null, barJobs = {};
 function showBar() {
  if (!bar) {
   bar = document.createElement('div');
   bar.className = 'cmpup';
   bar.setAttribute('role', 'status');
   bar.setAttribute('aria-live', 'polite');
   bar.innerHTML = '<p class="cmpup__t">Saving your design… <b>0%</b></p><span class="cmpup__m"><i></i></span>';
   var st = document.createElement('style');
   st.textContent = '.cmpup{position:fixed;left:50%;bottom:calc(16px + env(safe-area-inset-bottom,0px));transform:translateX(-50%);z-index:2147483000;width:min(340px,calc(100vw - 32px));padding:12px 14px;border-radius:12px;background:#16171a;color:#f4f4f2;box-shadow:0 8px 28px rgba(0,0,0,.35);font:500 14px/1.35 var(--cx-font,Arial,Helvetica,sans-serif)}' +
    '.cmpup__t{margin:0 0 8px}.cmpup__t b{font-variant-numeric:tabular-nums}.cmpup__m{display:block;height:6px;border-radius:3px;background:rgba(244,244,242,.16);overflow:hidden}' +
    '.cmpup__m i{display:block;height:100%;width:0;background:var(--cx-lava,#CFF516);transition:width .2s linear}@media (prefers-reduced-motion:reduce){.cmpup__m i{transition:none}}';
   bar.appendChild(st);
  }
  if (!bar.parentNode && document.body) document.body.appendChild(bar);
 }
 function paintBar() {
  var keys = Object.keys(barJobs);
  if (!keys.length) {
   if (bar && bar.parentNode) bar.parentNode.removeChild(bar);
   return;
  }
  var sum = 0;
  keys.forEach(function(k) { sum += barJobs[k]; });
  var pct = Math.min(99, Math.round(sum / keys.length * 100));
  showBar();
  bar.querySelector('b').textContent = pct + '%';
  bar.querySelector('i').style.width = pct + '%';
 }

 /* Shows the bar for one upload while Add to cart waits on it; returns a function that takes it away. */
 function barFor(job) {
  var item = live[job.key], t = null;
  if (!item) return function() {};
  barJobs[job.key] = 0;
  item.progress = function(f) { barJobs[job.key] = f; if (!t) paintBar(); };
  t = setTimeout(function() { t = null; paintBar(); }, 1200); // quick uploads never show a bar
  return function() {
   clearTimeout(t);
   item.progress = null;
   delete barJobs[job.key];
   paintBar();
  };
 }

 /* ---------- swapping a link on a cart line (only used when a file has to go the old way) ---------- */
 function patchCart(from, to, tries) {
  return nativeCart('/cart.js').then(function(cart) {
   var line = ((cart && cart.items) || []).filter(function(it) {
    var p = it.properties || {};
    return Object.keys(p).some(function(k) { return p[k] === from; });
   })[0];
   if (!line) {
    if (tries > 0) return sleep(2500).then(function() { return patchCart(from, to, tries - 1); });
    return false;
   }
   var props = {};
   Object.keys(line.properties).forEach(function(k) { props[k] = line.properties[k] === from ? to : line.properties[k]; });
   return prevFetch.call(window, '/cart/change.js', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json', Accept: 'application/json', 'X-CMP': '1' },
    body: JSON.stringify({ id: line.key, quantity: line.quantity, properties: props })
   }).then(function() {
    if (window.CMP && CMP.refreshCart) CMP.refreshCart(false);
    return true;
   });
  }).catch(function() { return false; });
 }
 function nativeCart(path) {
  return prevFetch.call(window, path, { headers: { Accept: 'application/json' } }).then(function(r) { return r.json(); });
 }
 /* The old way, for one file: returns {url, id} or null. */
 function legacy(url, init) {
  return prevFetch.call(window, url, init).then(function(r) { return r.json(); }).then(function(j) {
   return j && j.url ? j : null;
  }).catch(function() { return null; });
 }

 /* ---------- upload on pick: start sending the customer's file while they design ---------- */
 var picked = {}; // fingerprint -> { job, p }
 function fingerprint(blob) {
  if (!window.crypto || !crypto.subtle || !blob.arrayBuffer) return Promise.resolve(null);
  return blob.arrayBuffer().then(function(b) { return crypto.subtle.digest('SHA-256', b); }).then(function(h) {
   return Array.prototype.map.call(new Uint8Array(h), function(x) { return (x < 16 ? '0' : '') + x.toString(16); }).join('');
  }).catch(function() { return null; });
 }
 // capture phase: runs before the builder reads (and clears) the file input
 document.addEventListener('change', function(e) {
  var inp = e.target;
  if (!inp || inp.tagName !== 'INPUT' || inp.type !== 'file' || !inp.files || !inp.files.length) return;
  Array.prototype.forEach.call(inp.files, function(f) {
   var type = String(f.type || '').toLowerCase();
   if (type === 'image/jpg') type = 'image/jpeg';
   if (!EXTS[type] || f.size < 32 || f.size > 15 * 1024 * 1024) return;
   fingerprint(f).then(function(h) {
    if (!h || picked[h]) return;
    var job = { key: newKey(), name: 'upload-' + (f.name || 'file'), kind: 'customer', type: type, blob: f, at: Date.now() };
    job.url = PUB + 'k/' + job.key + '/' + baseName(job.name) + '.' + EXTS[type];
    var entry = picked[h] = { job: job, p: null };
    stash(job);
    entry.p = upload(job);
    entry.p.then(function(r) { if (r === 'refused') delete picked[h]; });
   });
  });
 }, true);

 /* ---------- the wrapper ---------- */
 window.fetch = function(resource, init) {
  var url = typeof resource === 'string' ? resource : resource && resource.url;
  if (!url || !LEGACY.test(url) || !init || String(init.method || '').toUpperCase() !== 'POST') return prevFetch.apply(this, arguments);
  var self = this, args = arguments;
  var j = bodyOf(init);
  var type = j ? mimeOf(j.base64Image, j.filename) : '';
  if (!j || !EXTS[type]) return prevFetch.apply(self, args); // SVG and anything else: the old way

  var blob;
  try {
   blob = toBlob(j.base64Image, type);
  } catch (e) {
   return prevFetch.apply(self, args);
  }
  var job = { key: newKey(), name: String(j.filename || 'file'), kind: kindOf(j.filename), type: type, blob: blob, at: Date.now() };
  job.url = PUB + 'k/' + job.key + '/' + baseName(job.name) + '.' + EXTS[type];
  var answer = { url: job.url, id: job.key };
  var wait = waitFor(job);

  // the same bytes the customer picked earlier: reuse that upload (made files, previews and print files, never match)
  var own = job.kind === 'customer' || job.kind === 'extra';
  return (own ? fingerprint(blob) : Promise.resolve(null)).then(function(h) {
   var hit = h && picked[h];
   if (!hit) return null;
   var stop = barFor(hit.job);
   return Promise.race([hit.p, sleep(WAIT.customer).then(function() { return 'late'; })]).then(function(r) {
    stop();
    return r === 'refused' ? null : jsonResponse({ url: hit.job.url, id: hit.job.key });
   });
  }).then(function(reused) {
   return reused || fresh();
  });

  function fresh() {
  stash(job);
  return Promise.resolve().then(function() {
   var p = upload(job);
   var stopBar = wait > 0 ? barFor(job) : function() {};
   return Promise.race([p, sleep(wait).then(function() { return 'late'; })]).then(function(r) {
    stopBar();
    if (r === 'refused') {
     // Storage turned this file down: send it the old way. If the builder already has our link, swap it on the cart line.
     var old = legacy(resource, init);
     if (wait > 0) return old.then(function(o) { return jsonResponse(o || { error: 'upload failed' }); });
     old.then(function(o) { if (o) patchCart(job.url, o.url, 6); });
     return jsonResponse(answer);
    }
    if (r === 'late' && wait === 0) p.then(function(x) {
     if (x === 'refused') legacy(resource, init).then(function(o) { if (o) patchCart(job.url, o.url, 6); });
    });
    return jsonResponse(answer); // done, or still going in the background
   });
  }, function() {
   return prevFetch.apply(self, args);
  });
  }
 };

 /* ---------- next page: finish anything left over ---------- */
 function resume() {
  resuming = jobs('all').then(function(list) {
   resuming = null; // done reading: from here on only uploads actually running hold up Check out
   (list || []).forEach(function(job) {
    job = revive(job);
    if (!job || !job.blob) return;
    if (Date.now() - job.at > DAY) return jobs('del', job.key);
    upload(job);
   });
  });
  // uploads started by the old fast add-to-cart (before Nov 2026): one more try each, then cleared
  db('cmp-uploads', 'jobs', 'tok').then(function(d) {
   if (!d) return;
   idb(d, 'jobs', 'all').then(function(list) {
    (list || []).forEach(function(old) {
     if (!old || Date.now() - old.at > DAY || !LEGACY.test(old.url || '')) return idb(d, 'jobs', 'del', old.tok);
     legacy(old.url, { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: old.body }).then(function(o) {
      idb(d, 'jobs', 'del', old.tok);
      if (o) patchCart(old.placeholder, o.url, 2);
     });
    });
   });
  });
 }

 /* ---------- cart pictures: show the phone's copy until the upload lands ---------- */
 document.addEventListener('error', function(e) {
  var img = e.target;
  if (!img || img.tagName !== 'IMG' || img.__cmpLocal) return;
  var src = img.currentSrc || img.src || '';
  var m = src.indexOf(PUB) === 0 && /\/k\/([a-z0-9]+)\//.exec(src);
  if (!m) return;
  img.__cmpLocal = true;
  var hit = live[m[1]];
  (hit ? Promise.resolve(hit.job) : jobs('get', m[1])).then(function(job) {
   job = revive(job);
   if (!job || !job.blob) return;
   img.removeAttribute('srcset');
   img.src = URL.createObjectURL(job.blob);
  });
 }, true);

 /* ---------- check out waits for anything still uploading ---------- */
 var resuming = null; // resume()'s read of the phone copies
 function busy() {
  var on = Object.keys(live).length > 0, h = document.documentElement;
  if (h && h.classList) h.classList.toggle('cmpup-busy', on);
 }
 (function() {
  var st = document.createElement('style');
  // Shop Pay / Apple Pay buttons live in Shopify's own frame, so they're paused (not clickable) until the files land
  st.textContent = '.cmpup-busy .cxk__express,.cmpup-busy shopify-accelerated-checkout-cart,.cmpup-busy .shopify-payment-button{pointer-events:none;opacity:.45;transition:opacity .2s}';
  (document.head || document.documentElement).appendChild(st);
 })();
 function settle(maxMs) {
  var stops = Object.keys(live).map(function(k) { return barFor(live[k].job); });
  var all = Promise.all(Object.keys(live).map(function(k) { return live[k].p; }));
  return Promise.race([all, sleep(maxMs)]).then(function() { stops.forEach(function(f) { f(); }); });
 }
 var passing = false, lastSub = null;
 document.addEventListener('click', function(e) {
  var b = e.target && e.target.closest && e.target.closest('button[name="checkout"],input[name="checkout"]');
  if (b) lastSub = b;
  var a = !passing && e.target && e.target.closest && e.target.closest('a[href*="/checkout"]');
  if (!a || !Object.keys(live).length) return; // nothing uploading: the link works exactly as before
  e.preventDefault();
  e.stopImmediatePropagation();
  settle(60000).then(function() { location.href = a.href; });
 }, true);
 document.addEventListener('submit', function(e) {
  if (passing) return;
  var f = e.target, sub = e.submitter || (lastSub && lastSub.form === f ? lastSub : null);
  var isCheckout = (sub && sub.name === 'checkout') || /\/checkout/.test((f && f.getAttribute && f.getAttribute('action')) || '');
  if (!isCheckout || !Object.keys(live).length) return; // nothing uploading: Check out works exactly as before
  e.preventDefault();
  e.stopImmediatePropagation();
  settle(60000).then(function() {
   // plain form.submit() (not requestSubmit): the most reliable way to go on in every browser, Instagram's and
   // Facebook's included. It skips submit handlers, so the checkout button's name/value is added by hand.
   passing = true;
   if (sub && sub.name && !f.querySelector('input[type=hidden][name="' + sub.name + '"]')) {
    var h = document.createElement('input');
    h.type = 'hidden'; h.name = sub.name; h.value = sub.value || '1';
    f.appendChild(h);
   } else if (!sub && !f.querySelector('input[name="checkout"]')) {
    var h2 = document.createElement('input');
    h2.type = 'hidden'; h2.name = 'checkout'; h2.value = '1';
    f.appendChild(h2);
   }
   HTMLFormElement.prototype.submit.call(f);
   setTimeout(function() { passing = false; }, 0);
  });
 }, true);

 if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', resume);
 else resume();

 window.CMPUploads = { pending: function() { return Object.keys(live).length; }, kindOf: kindOf, baseName: baseName };
})();
